import { render, staticRenderFns } from "./SimpleFormation.vue?vue&type=template&id=018aafb8&scoped=true"
import script from "./SimpleFormation.vue?vue&type=script&lang=js"
export * from "./SimpleFormation.vue?vue&type=script&lang=js"
import style0 from "./SimpleFormation.vue?vue&type=style&index=0&id=018aafb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018aafb8",
  null
  
)

export default component.exports